module.exports = __webpack_public_path__ + "img/icon-instagram.0969c204.svg";